module.exports = "./img/44f6e6f17f99d8ff0ae073b75af86e14.jpg";